'use client';

import { FiSearch } from '@react-icons/all-files/fi/FiSearch';
import { useCallback, useState } from 'react';

import SearchBar from '~/shared/components/header/components/search-bar';
import Modal from '~/shared/components/modal';

import '~/shared/components/header/components/search/search.scss';

const Search = ({ lng }) => {
  const [isModalOpen, changeStateOfModal] = useState(false);
  const toggleModal = useCallback(() => {
    changeStateOfModal(true);
  }, []);
  const [isResetForm, setIsResetForm] = useState(false);

  return (
    <>
      <div className="search" onClick={toggleModal}>
        <FiSearch />
      </div>
      <Modal
        closeIcon={false}
        centered={false}
        withNoFooter
        mask={false}
        wrapClassName="search__modal"
        width="100vw"
        isModalOpen={isModalOpen}
        changeStateOfModal={changeStateOfModal}
        onCancel={() => {
          setIsResetForm(true);
        }}
      >
        <SearchBar
          isResetForm={isResetForm}
          lng={lng}
          setIsResetForm={setIsResetForm}
          isModalOpen={isModalOpen}
          changeStateOfModal={changeStateOfModal}
        />
      </Modal>
    </>
  );
};

export default Search;
